import * as React from "react"
import * as Moment from "moment"

import { Link } from "./library/link"
import { getCurrentFilterQuery } from "./filters"
import { TeaserContent, TeaserContentProps } from "./teaser"
import { slugify } from "../../custom_utils/helpers"

export type ActivitySummaryProps = {
  title: string
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  subtitle: string
  date: Date | "multiple"
  location: string | "multiple"
  imageUrl: string
  imageAlt: string
  route: string
  onClick?: () => void
  isTip: boolean
}

export const ActivitySummary = (p: ActivitySummaryProps & { row_count: number } ): JSX.Element => (
  p.title == "loading" ? <></> : (
    <li className={`teaser teaser--image ${p.row_count == 4 ? 'col-xs-12 col-sm-6 col-md-4 col-ld-3' : 'col-xs-12 col-sm-6 col-md-4'} `}>
      <Link
        key={p.route}
        url={`${p.route}${getCurrentFilterQuery()}`}
        className="teaser__link"
        handle={() => p.onClick && p.onClick()}
        aria-labelledby={`a11y-teaser-title-${slugify(p.title)}`}
      >
        <TeaserContent
          headingLevel={p.headingLevel}
          title={p.title}
          isTip={p.isTip}
          imageUrl={p.imageUrl}
          imageAlt={p.imageAlt}
          label={p.date == "multiple" ? <></> : (
            <time dateTime={Moment(p.date).format('L')}>
              {Moment(p.date).format("dd L")}
            </time>
          )}
          intro={p.subtitle}
          footer={p.location == "multiple" ? "Meerdere locaties" : p.location}
        />
      </Link>
    </li>
  )
)